import { Component, OnInit } from '@angular/core';
declare function init_plugins();

@Component({
  standalone: false,
  selector: 'app-monitoreo',
  templateUrl: './monitoreo.component.html',
  styleUrls: []
})
export class MonitoreoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    init_plugins();

  }

}
